/**
 * Validates that a provided signature string is non-empty and plausibly long enough.
 * @param signature - The signature string to validate.
 * @throws Error if the signature is empty or too short.
 */
export function assertValidSignatureInput(signature?: string): void {
  if (!signature || signature.trim() === '') {
    throw new Error('Signature cannot be empty')
  }
  if (signature.length < 10) {
    throw new Error('Signature appears to be too short')
  }
}
